/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import AdjustOutlinedIcon from "@mui/icons-material/AdjustOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import ImportantDevicesOutlinedIcon from "@mui/icons-material/ImportantDevicesOutlined";
import MarkunreadMailboxOutlinedIcon from "@mui/icons-material/MarkunreadMailboxOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import GohonzonIcon from "../../assets/svg/sidebar/Gohonzon";
import AppointmentIcon from "../../assets/svg/sidebar/Appointment";
import ExaminationIcon from "../../assets/svg/sidebar/Examination";
import FriendIcon from "../../assets/svg/sidebar/Friend";
import HelpIcon from "../../assets/svg/sidebar/Help";
import IntroductionIcon from "../../assets/svg/sidebar/Introduction";
import MeetingAttendanceIcon from "../../assets/svg/sidebar/MeetingAttendance";
import MemberIcon from "../../assets/svg/sidebar/Member";
import OperationalStrutureIcon from "../../assets/svg/sidebar/OperationStructure";
import { PERMISSIONS } from "../../contants";
import { ROUTES } from "../../utils/constants";
import Styles from "./styles";
import style from "../common/Modal/styles";
import styles from "../common/AppliedFilter/AppliedFilter.styles";
import ArrowIcon from "../../assets/svg/Arrow";
import AddPlusIcon from "../../assets/svg/addPlusIcon";
import AddIcon from "../../assets/svg/AddIcon";

const SETTINGS = "settings";
const CHAPTER_SI = "chapterSI";
const helpDesk = "helpDesk";
const DISTRICT_SI = "districtSI";
const DISTRICT_LEADER = "districtLeader";
const helpDeskAdmin = "helpDeskAdmin";
const REGION_SI = "regionSI";
const FILE_UPLOADING = "fileUploading";

const INTRODUCTION = "introduction";
const FRIEND = "friend";
const MARK_ATTENDANCE = "attendance";
const ARCHIVE_ATTENDANCE = "archiveAttendance";
const GOHONZON = "gohonzon";
const APPOINTMENT = "appointment";
const MEMBER = "member";
const ALLOTMENT = "allotment";
const REPORTS = "reports";
const NEW_STRUCTURE = "new-structure";
const SPECIAL_GROUP = "special-group";
const DIVISION_GRADUATION = "divisionGraduation";
const EMAILER = "emailer";
const TICKET_SYSTEM = "ticketSystem";
const EXAMINATION = "examination";

// 🔥 Helper function for attendance permissions (DRY principle)
const hasAttendancePermission = (hasPermission) => {
  return (
    hasPermission(PERMISSIONS.MARK_DISCUSSION) ||
    hasPermission(PERMISSIONS.MARK_GOSHO) ||
    // hasPermission(PERMISSIONS.MARK_NHR) ||
    hasPermission(PERMISSIONS.MARK_CUBS) ||
    hasPermission(PERMISSIONS.MARK_YL) ||
    hasPermission(PERMISSIONS.MARK_YP) ||
    hasPermission(PERMISSIONS.MARK_SD)
  );
};

const DRAWER_ITEMS = [
  // {
  //   title: "Dashboard",
  //   key: "dashboard  ",
  //   isParent: true,
  //   icon: <HelpIcon />,
  //   path: ROUTES.HOME.path,
  // },
  {
    title: "Introduction",
    key: INTRODUCTION,
    icon: <PersonOutlineOutlinedIcon style={Styles.fontMedium} />,
    path: "/introduction",
    isParent: true,
    members: [
      {
        title: "Create",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: "/introduction/create",
      },
      {
        title: "View",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: "/introduction/view",
      },
    ],
  },
  {
    title: "Friends",
    icon: <HomeOutlinedIcon />,
    path: "/friends",
    key: FRIEND,
    isParent: true,
    members: [
      {
        title: "Search",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.FRIEND_SEARCH.path,
      },
      {
        title: "Transfer",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: `/${ROUTES.FRIEND_TRANSFER.path}`,
      },
      {
        title: "Create",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: `/${ROUTES.NEW_FRIEND_SEARCH.path}`,
      },
    ],
  },
  {
    title: "Members",
    icon: <MemberIcon />,
    path: "/members",
    key: MEMBER,
    isParent: true,
    members: [
      {
        title: "Search",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.MEMBER_SEARCH.path,
      },
      {
        title: "Transfer",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.MEMBER_TRANSFER.path,
      },
      {
        title: "Create",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.NEW_MEMBER.path,
      },
      {
        title: "Deactivation",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.MEMBER_DEACTIVATION.path,
      },
      // {
      //   title: "Reactivation",
      //   icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
      //   path: ROUTES.MEMBER_REACTIVATION.path,
      // },
      // {
      //   title: "Create Family",
      //   icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
      //   path: ROUTES.CREATE_NEW_FAMILY.path,
      // },
      // {
      //   title: "Search Family",
      //   icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
      //   path: ROUTES.FAMILY_DETAIL.path,
      // },
    ],
  },
  {
    title: "Reports",
    icon: <ExaminationIcon />,
    path: "/reports",
    key: REPORTS,
    isParent: true,
    members: [
      {
        title: "Members",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.REPORTS_MEMBER.path,
      },
      {
        title: "Friends",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.REPORTS_FRIEND.path,
      },
      {
        title: "Deactivated",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.REPORTS_DEACTIVATED_FRIEND.path,
      },
      {
        title: "Change to Member",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.REPORTS_CHANGED_TO_MEMBER.path,
      },
      {
        title: "Attendance",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.REPORTS_ATTENDANCE.path,
      },
      {
        title: "Conferral",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.REPORTS_GOHONZON_CONFERRAL.path,
      },
      {
        title: "Allotment",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.REPORTS_GOHONZON_ALLOTMENT.path,
      },
      {
        title: "Downloads",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.DOWNLOAD_REPORTS.path,
      },
    ],
  },
  {
    title: "Emailer",
    key: EMAILER,
    isParent: true,
    icon: <EmailOutlinedIcon style={Styles.settingIcon} />,
    path: "/emailer",
    members: [
      {
        title: "Create Template",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.EMAILER_EDITOR.path,
      },
      {
        title: "Template List",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.TICKET_LIST.path,
      },
    ],
  },
  {
    title: "Attendance",
    key: "attendance",
    isParent: true,
    icon: <TouchAppIcon style={Styles.settingIcon} />,
    path: ROUTES.MARK_ATTENDANCE.path,
  },
  {
    title: "Gohonzon",
    key: "gohonzon",
    isParent: true,
    icon: <GohonzonIcon />,
    path: ROUTES.GOHONZON.path,
    members: [],
  },
  {
    title: "BDS Contents",
    key: FILE_UPLOADING,
    isParent: true,
    icon: <SettingsIcon />,
    path: ROUTES.FILES_LIST.path,
  },
  // {
  //   title: "Appointment",
  //   key: "appointment",
  //   isParent: true,
  //   icon: <GohonzonIcon />,
  //   path: "/",
  //   members: [
  //     {
  //       title: "Appointment entry",
  //       icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
  //       path: ROUTES.APPOINTMENT_SUBMISSION.path,
  //     },
  //   ],
  // },
  {
    title: "Appointment",
    key: "appointment",
    isParent: true,
    icon: <MarkunreadMailboxOutlinedIcon />,
    path: ROUTES.APPOINTMENT.path,
    members: [],
  },
  {
    title: "New Structure",
    key: NEW_STRUCTURE,
    isParent: true,
    icon: <AccountTreeOutlinedIcon style={Styles.settingIcon} />,
    path: ROUTES.NEW_STRUCTURE.path,
    members: [],
  },
  // {
  //   title: "Examination",
  //   icon: <ExaminationIcon />,
  //   path: "/examination",
  //   key: EXAMINATION,
  //   isParent: true,
  //   members: {
  //     title: "Search",
  //     icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
  //     path: ROUTES.EXAMINATION_MEMBER_SEARCH.path,
  //   },
  // },
  {
    title: "Special Group",
    key: SPECIAL_GROUP,
    icon: <AutoAwesomeOutlinedIcon style={Styles.fontMedium} />,
    path: "/special-group",
    isParent: true,
    members: [
      {
        title: "Induction",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: "/special-group/induction",
      },
      {
        title: "Graduation",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: "/special-group/graduation",
      },
    ],
  },
  {
    title: "Division Graduation",
    key: DIVISION_GRADUATION,
    icon: <SchoolOutlinedIcon style={Styles.settingIcon} />,
    path: ROUTES.SG_DIVISION.path,
    isParent: true,
    members: [],
  },
  {
    title: "Settings",
    key: SETTINGS,
    isParent: true,
    icon: <SettingsIcon />,
    path: ROUTES.SETTINGS.path,
    members: [
      {
        title: "Announcement",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.VIEW_ANNOUNCEMENT.path,
      },
      {
        title: "University",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.UNIVERSITY_LIST.path,
      },
      {
        title: "User Management",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.USER_MANAGEMENT.path,
      },
      {
        title: "Roles",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.USER_MANAGEMENT_MEMBER_SEARCH.path,
      },
      {
        title: "Permissions",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.USER_PERMISSION_MANAGEMENT.path,
      },
    ],
  },
  // {
  //   title: "Examination",
  //   key: "examination",
  //   isParent: true,
  //   icon: <ExaminationIcon />,
  //   path: ROUTES.EXAMINATIONS.path,
  // },
  // {
  //   title: "Organization Structure",
  //   key: "operational_structure",
  //   isParent: true,
  //   icon: <OperationalStrutureIcon />,
  //   path: ROUTES.ORGANIZATION_STRUCTURE.path,
  // },

  {
    title: "Ticket System",
    key: TICKET_SYSTEM,
    isParent: true,
    icon: <ImportantDevicesOutlinedIcon style={Styles.settingIcon} />,
    path: "/ticketSystem",
    members: [
      {
        title: "Create Ticket",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.TICKET_CREATE.path,
      },
      {
        title: "Ticket List",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.EMAILER_TEMPLATES.path,
      },
    ],
  },

  // {
  //   title: "Help",
  //   key: "help",
  //   isParent: true,
  //   icon: <HelpIcon />,
  //   path: ROUTES.HELP_PAGE.path,
  // },
];

export const getDrawerItems = (hasPermission, userRole) =>
  DRAWER_ITEMS.reduce((accum, current) => {
    const { key } = current;
    if (key === INTRODUCTION) {
      if (
        hasPermission(PERMISSIONS.INITIATE_INTRODUCTION) ||
        hasPermission(PERMISSIONS.VIEW_PENDING_INTRODUCTION)
      ) {
        accum.push({
          title: "Introduction",
          key: INTRODUCTION,
          icon: <IntroductionIcon style={Styles.settingIcon} />,
          path: "/introduction",
          isParent: true,
          members: [
            hasPermission(PERMISSIONS.INITIATE_INTRODUCTION) && {
              title: "Create",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: "/introduction/create",
            },
            hasPermission(PERMISSIONS.VIEW_PENDING_INTRODUCTION) &&
              userRole !== helpDesk &&
              userRole !== helpDeskAdmin && {
                title: "View",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: "/introduction/view",
              },
            hasPermission(PERMISSIONS.VIEW_PENDING_INTRODUCTION) &&
              (userRole === helpDesk || userRole === helpDeskAdmin) && {
                title: "Request",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.INTRODUCTION_TRANSFER_REQUEST.path,
              },
          ].filter(Boolean),
        });
      }
    } else if (key === FRIEND) {
      if (
        hasPermission(PERMISSIONS.CREATE_NEW_ENTRY_FRIEND) ||
        hasPermission(PERMISSIONS.VIEW_PENDING_FRIEND)
      ) {
        accum.push({
          title: "Friends",
          icon: <FriendIcon style={Styles.settingIcon} />,
          path: "/friend",
          isParent: true,
          key: FRIEND,
          members: [
            {
              title: hasPermission(PERMISSIONS.UPDATE_FRIEND)
                ? "Search/Edit"
                : "Search",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.FRIEND_SEARCH.path,
            },
            hasPermission(PERMISSIONS.VIEW_PENDING_FRIEND) &&
              userRole !== helpDesk &&
              userRole !== helpDeskAdmin && {
                title: "Pending Transfer",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: `/${ROUTES.FRIEND_TRANSFER.path}`,
              },
            hasPermission(PERMISSIONS.VIEW_PENDING_FRIEND) &&
              (userRole === helpDesk || userRole === helpDeskAdmin) && {
                title: "Transfer Request",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: `/${ROUTES.FRIEND_TRANSFER_REQUEST.path}`,
              },
            // hasPermission(PERMISSIONS.CREATE_NEW_ENTRY_FRIEND) && {
            //   title: "Create",
            //   icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
            //   path: `/${ROUTES.NEW_FRIEND_SEARCH.path}`,
            // },
          ].filter(Boolean),
        });
      }
    } else if (key === MEMBER) {
      if (
        hasPermission(PERMISSIONS.CREATE_NEW_FAMILY) ||
        hasPermission(PERMISSIONS.VIEW_FAMILY_DETAILS) ||
        hasPermission(PERMISSIONS.VIEW_SEARCH_MEMBER) ||
        hasPermission(PERMISSIONS.VIEW_PENDING_MEMBER) ||
        hasPermission(PERMISSIONS.CREATE_NEW_ENTRY_MEMBER)
      ) {
        accum.push({
          title: "Members",
          icon: <MemberIcon />,
          path: "/members",
          isParent: true,
          key: MEMBER,
          members: [
            hasPermission(PERMISSIONS.VIEW_SEARCH_MEMBER) && {
              title: "Search",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.MEMBER_SEARCH.path,
            },
            hasPermission(PERMISSIONS.VIEW_PENDING_MEMBER) &&
              userRole !== helpDesk &&
              userRole !== helpDeskAdmin && {
                title: "Transfer",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.MEMBER_TRANSFER.path,
              },
            hasPermission(PERMISSIONS.VIEW_PENDING_MEMBER) &&
              (userRole === helpDesk || userRole === helpDeskAdmin) && {
                title: "Transfer Request",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.MEMBER_REQUEST.path,
              },
            hasPermission(PERMISSIONS.CREATE_NEW_ENTRY_MEMBER) && {
              title: "Add Member",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.NEW_MEMBER_CREATE.path,
            },
            (userRole === helpDesk || userRole === helpDeskAdmin) && {
              title: "Deactivation",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.MEMBER_DEACTIVATION.path,
            },
            // (userRole === helpDesk || userRole === helpDeskAdmin) && {
            //   title: "Reactivation",
            //   icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
            //   path: ROUTES.MEMBER_REACTIVATION.path,
            // },
            hasPermission(PERMISSIONS.CREATE_NEW_FAMILY) && {
              title: "Create Family",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.CREATE_NEW_FAMILY.path,
            },
            hasPermission(PERMISSIONS.VIEW_FAMILY_DETAILS) && {
              title: "Search Family",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.FAMILY_DETAIL.path,
            },
          ].filter(Boolean),
        });
      }
    } else if (key === REPORTS) {
      if (
        hasPermission(PERMISSIONS.MEMBER_GENERAL_REPORT) ||
        hasPermission(PERMISSIONS.FRIEND_GENERAL_REPORT) ||
        hasPermission(PERMISSIONS.ATTENDANCE_REPORT_STATS) ||
        hasPermission(PERMISSIONS.CONNECTION_REPORT_STATS) ||
        hasPermission(PERMISSIONS.SUBSCRIPTION_REPORT) ||
        hasPermission(PERMISSIONS.SUBSCRIPTION_REPORT_TREND) ||
        hasPermission(PERMISSIONS.SUBSCRIPTION_REPORT_MIS)
      ) {
        accum.push({
          title: "Reports",
          icon: <ExaminationIcon />,
          path: "/reports",
          isParent: true,
          key: REPORTS,
          members: [
            hasPermission(PERMISSIONS.MEMBER_GENERAL_REPORT) && {
              title: "Members",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.REPORTS_MEMBER.path,
            },
            // {
            //   title: "Friends",
            //   icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
            //   path: ROUTES.REPORTS_FRIEND.path,
            // },
            {
              title: "Friends",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              isParent: true,
              members: [
                {
                  title: "Friends List",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_FRIEND.path,
                },
                // TEMP: Moved Friend to Member Growth here for testing
                {
                  title: "Friend to Member Growth",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_FRIEND_TO_MEMBER_GROWTH.path,
                },
                {
                  title: "Deactivated",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_DEACTIVATED_FRIEND.path,
                },
                {
                  title: "Change to Member",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_CHANGED_TO_MEMBER.path,
                },
                hasPermission(PERMISSIONS.FRIEND_AGEING_REPORT) && {
                  title: "Friend Ageing",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_FRIEND_AGEING.path,
                },
                // hasPermission(PERMISSIONS.FRIEND_SUMMARY_REPORT) && {
                //   title: "Friend Summary",
                //   icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                //   path: ROUTES.REPORTS_FRIEND_SUMMARY.path,
                // },
                // hasPermission(PERMISSIONS.FRIEND_CHANGE_TO_MEMBER_TREND) && {
                //   title: "Member Trend",
                //   icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                //   path: ROUTES.REPORTS_FRIEND_CHANGED_TO_MEMBER_TRENDS.path,
                // },
                hasPermission(PERMISSIONS.FRIEND_NEW_FRIEND_TREND) && {
                  title: "New Friend Trend",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_NEW_FRIEND_TRENDS.path,
                },
              ].filter(Boolean),
            },
            {
              title: "Attendance",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              isParent: true,
              members: [
                {
                  title: "Member Wise",
                  icon: (
                    <AdjustOutlinedIcon
                      style={{ fontSize: 13, color: "#fff" }}
                    />
                  ),
                  path: ROUTES.REPORTS_ATTENDANCE.path,
                },
                hasPermission(PERMISSIONS.ATTENDANCE_REPORT_STATS) && {
                  title: "Structure Wise",
                  icon: (
                    <AdjustOutlinedIcon
                      style={{ fontSize: 13, color: "#fff" }}
                    />
                  ),
                  path: ROUTES.STRUCTURE_ATTENDANCE_REPORT.path,
                },
                {
                  title: "Unmarked",
                  icon: (
                    <AdjustOutlinedIcon
                      style={{ fontSize: 13, color: "#fff" }}
                    />
                  ),
                  path: ROUTES.UNMARKED_ATTENDANCE_REPORT.path,
                },
                hasAttendancePermission(hasPermission) && {
                  title: "Archived",
                  icon: (
                    <AdjustOutlinedIcon
                      style={{ fontSize: 13, color: "#fff" }}
                    />
                  ),
                  path: ROUTES.ARCHIVE_MARK_ATTENDANCE.path,
                },
              ].filter(Boolean),
            },
            {
              title: "Gohonzon",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              isParent: true,
              members: [
                {
                  title: "Allotment",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_GOHONZON_ALLOTMENT.path,
                },
                {
                  title: "Conferral",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_GOHONZON_CONFERRAL.path,
                },
              ].filter(Boolean),
            },
            // hasPermission(PERMISSIONS.CONNECTION_REPORT_STATS) && {
            //   title: "Stats",
            //   icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
            //   isParent: true,
            //   members: [
            //     {
            //       title: "Current Stats",
            //       icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
            //       path: ROUTES.REPORTS_CURRENT_STATS.path,
            //     },
            //   ].filter(Boolean),
            // },
            {
              title: "Statistics",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.REPORTS_CURRENT_STATS.path,
              isParent: false,
              // members: [
              //   {
              //     title: "Statistics",
              //     icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              //     path: ROUTES.REPORTS_CURRENT_STATS.path,
              //   },
              // ].filter(Boolean),
            },

            hasPermission(PERMISSIONS.SUBSCRIPTION_REPORT) && {
              title: "Subscription",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              isParent: true,
              members: [
                {
                  title: "Subscription",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_SUBSCRIPTION.path,
                },
                hasPermission(PERMISSIONS.SUBSCRIPTION_REPORT_TREND) && {
                  title: "Subscription Trends",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_SUBSCRIPTION_TRENDS.path,
                },
                hasPermission(PERMISSIONS.SUBSCRIPTION_REPORT_MIS) && {
                  title: "Subscription Mis",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_SUBSCRIPTION_MIS.path,
                },
                hasPermission(PERMISSIONS.SUBSCRIPTION_REPORT_EXPIRED) && {
                  title: "Expired Subscription",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_EXPIRED_SUBSCRIPTION.path,
                },
                hasPermission(
                  PERMISSIONS.SUBSCRIPTION_REPORT_NEAR_TO_EXPIRY
                ) && {
                  title: "Near To Expiry",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REPORTS_NEAR_TO_EXPIRY_SUBSCRIPTION.path,
                },
              ].filter(Boolean),
            },
            hasPermission(PERMISSIONS.SEARCH_EXAMINATION_MEMBERS) && {
              title: "Examination",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              isParent: true,
              members: [
                hasPermission(PERMISSIONS.SEARCH_EXAMINATION_MEMBERS) && {
                  title: "Eligible",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.EXAMINATION_MEMBER_SEARCH.path,
                },
                hasPermission(
                  PERMISSIONS.SEARCH_EXAMINATION_APPLIED_MEMBERS
                ) && {
                  title: "Applied",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.APPLIED_MEMBER_SEARCH.path,
                },
                hasPermission(
                  PERMISSIONS.SEARCH_EXAMINATION_MEMBERS_RESULT
                ) && {
                  title: "BSG Intermediate Examination 2025 Result",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.RESULT_MEMBER_SEARCH.path,
                },
              ].filter(Boolean),
            },
            {
              title: "Downloads",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.DOWNLOAD_REPORTS.path,
            },
          ].filter(Boolean),
        });
      }
      // } else if (key === EXAMINATION) {
      //   if (hasPermission(PERMISSIONS.SEARCH_EXAMINATION_MEMBERS)) {
      //     accum.push({
      //       title: "Examination",
      //       icon: <ExaminationIcon />,
      //       path: "/examination",
      //       isParent: true,
      //       key: EXAMINATION,
      //       members: [
      //         hasPermission(PERMISSIONS.SEARCH_EXAMINATION_MEMBERS) && {
      //           title: "Search",
      //           icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
      //           path: ROUTES.EXAMINATION_MEMBER_SEARCH.path,
      //         },
      //       ].filter(Boolean),
      //     });
      //   }
    } else if (key === SPECIAL_GROUP) {
      if (
        hasPermission(PERMISSIONS.SPECIAL_GROUP_INDUCTION) ||
        hasPermission(PERMISSIONS.SPECIAL_GROUP_GRADUATION) ||
        hasPermission(PERMISSIONS.SPECIAL_GROUP_GRADUATION_CREATE) ||
        hasPermission(PERMISSIONS.SPECIAL_GROUP_INDUCTION_CREATE) ||
        hasPermission(PERMISSIONS.SEARCH_SPECIAL_GROUP)
      ) {
        accum.push({
          title: "Special Group",
          icon: <AutoAwesomeOutlinedIcon style={Styles.settingIcon} />,
          path: "/special-group",
          isParent: true,
          key: SPECIAL_GROUP,
          members: [
            hasPermission(PERMISSIONS.SEARCH_SPECIAL_GROUP) &&
              hasPermission(PERMISSIONS.SPECIAL_GROUP_INDUCTION) &&
              hasPermission(PERMISSIONS.SPECIAL_GROUP_INDUCTION_CREATE) && {
                title: "Induction",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.SG_INDUCTION.path,
              },
            hasPermission(PERMISSIONS.SPECIAL_GROUP_GRADUATION) &&
              hasPermission(PERMISSIONS.SPECIAL_GROUP_GRADUATION_CREATE) && {
                title: "Graduation",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.SG_GRADUATION.path,
              },
          ].filter(Boolean),
        });
      }
    } else if (key === DIVISION_GRADUATION) {
      if (hasPermission(PERMISSIONS.DIVISION_GRADUATION)) {
        accum.push({
          title: "Division Graduation",
          key: DIVISION_GRADUATION,
          icon: <SchoolOutlinedIcon style={Styles.settingIcon} />,
          path: ROUTES.SG_DIVISION.path,
          isParent: true,
        });
      }
    } else if (key === EMAILER) {
      if (
        hasPermission(PERMISSIONS.CREATE_EMAIL_TEMPLATE) ||
        hasPermission(PERMISSIONS.READ_EMAIL_TEMPLATE)
      ) {
        accum.push({
          title: "Emailer",
          key: "emailer",
          isParent: true,
          icon: <EmailOutlinedIcon style={Styles.settingIcon} />,
          path: ROUTES.EMAILER.path,
          members: [
            hasPermission(PERMISSIONS.CREATE_EMAIL_TEMPLATE) && {
              title: "Create Template",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.EMAILER_EDITOR.path,
            },
            hasPermission(PERMISSIONS.READ_EMAIL_TEMPLATE) && {
              title: "Template List",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.EMAILER_TEMPLATES.path,
            },
          ].filter(Boolean),
        });
      }
    } else if (key === MARK_ATTENDANCE) {
      if (hasAttendancePermission(hasPermission)) {
        accum.push({
          title: "Attendance",
          key: "attendance",
          isParent: true,
          icon: <TouchAppIcon style={Styles.settingIcon} />,
          path: ROUTES.MARK_ATTENDANCE.path,
        });
      }
    } else if (key === ARCHIVE_ATTENDANCE) {
      if (hasAttendancePermission(hasPermission)) {
        accum.push({
          title: "Archive Attendance",
          key: "archiveAttendance",
          isParent: true,
          icon: <MeetingAttendanceIcon />,
          path: ROUTES.ARCHIVE_MARK_ATTENDANCE.path,
        });
      }
    } else if (key === FILE_UPLOADING) {
      // if ("") {
      if (hasPermission(PERMISSIONS.READALL_CONTENT)) {
        accum.push({
          title: "BDS Contents",
          key: FILE_UPLOADING,
          isParent: true,
          icon: <AddIcon color="#8c8c8c" />,
          path: ROUTES.FILES_LIST.path,
        });
      }
      // }
    } else if (key === GOHONZON) {
      if (
        hasPermission(PERMISSIONS.VIEW_OKATAKI_APPLICATION_GOHONZON) ||
        hasPermission(PERMISSIONS.VIEW_OMAMORI_APPLICATION_GOHONZON) ||
        hasPermission(
          PERMISSIONS.VIEW_OKATAKI_APPLICATION_FOR_MEMBER_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.VIEW_OMAMORI_APPLICATION_FOR_MEMBER_GOHONZON
        ) ||
        hasPermission(PERMISSIONS.CREATE_OKATAKI_APPLICATION_GOHONZON) ||
        hasPermission(PERMISSIONS.CREATE_OMAMORI_APPLICATION_GOHONZON) ||
        hasPermission(PERMISSIONS.VIEW_OKATAKI_APPLICATION_REMARK_GOHONZON) ||
        hasPermission(PERMISSIONS.VIEW_OMAMORI_APPLICATION_REMARK_GOHONZON) ||
        hasPermission(PERMISSIONS.CREATE_BATCH_GOHONZON) ||
        hasPermission(PERMISSIONS.VIEW_BATCH_GOHONZON) ||
        hasPermission(
          PERMISSIONS.CREATE_OKATAKI_APPLICATION_RETURN_REQUEST_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.CREATE_OMAMORI_APPLICATION_RETURN_REQUEST_GOHONZON
        ) ||
        hasPermission(PERMISSIONS.VIEW_SPECIAL_APPLICATION_GOHONZON) ||
        hasPermission(PERMISSIONS.UPDATE_OKATAKI_APPLICATION_GOHONZON) ||
        hasPermission(PERMISSIONS.UPDATE_OMAMORI_APPLICATION_GOHONZON) ||
        hasPermission(PERMISSIONS.VIEW_OKATAKI_APPLICATION_REMARK_GOHONZON) ||
        hasPermission(PERMISSIONS.UPDATE_OKATAKI_APPLICATION_OTP_GOHONZON) ||
        hasPermission(PERMISSIONS.CANCEL_OKATAKI_GOHONZON) ||
        hasPermission(PERMISSIONS.CANCEL_OMAMORI_GOHONZON) ||
        hasPermission(PERMISSIONS.CREATE_BATCH_GOHONZON) ||
        hasPermission(PERMISSIONS.VIEW_BATCH_GOHONZON) ||
        hasPermission(
          PERMISSIONS.UPDATE_OKATAKI_APPLICATION_CONFERRAL_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.UPDATE_OMAMORI_APPLICATION_CONFERRAL_GOHONZON
        ) ||
        hasPermission(PERMISSIONS.UPDATE_OKATAKI_APPLICATION_RETURN_GOHONZON) ||
        hasPermission(
          PERMISSIONS.UPDATE_OKATAKI_APPLICATION_INTERVIEW_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.UPDATE_OMAMORI_APPLICATION_INTERVIEW_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.CREATE_OKATAKI_APPLICATION_RETURN_REQUEST_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.CREATE_OMAMORI_APPLICATION_RETURN_REQUEST_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.ALLOTMENT_OKATAKI_APPLICATION_CANCEL_REQUEST_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.ALLOTMENT_OMAMORI_APPLICATION_CANCEL_REQUEST_GOHONZON
        ) ||
        hasPermission(PERMISSIONS.UPDATE_OMAMORI_APPLICATION_RETURN_GOHONZON) ||
        hasPermission(
          PERMISSIONS.UPDATE_OMAMORI_APPLICATION_FINAL_INTERVIEW_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.UPDATE_OMAMORI_APPLICATION_RETURN_REQUEST_GOHONZON
        ) ||
        hasPermission(PERMISSIONS.VIEW_SPECIAL_APPLICATION_GOHONZON) ||
        hasPermission(
          PERMISSIONS.UPDATE_SPECIAL_APPLICATION_CONFERRAL_GOHONZON
        ) ||
        hasPermission(PERMISSIONS.UPDATE_SPECIAL_APPLICATION_RETURN_GOHONZON) ||
        hasPermission(PERMISSIONS.VIEW_SPECIAL_APPLICATION_REMARK_GOHONZON) ||
        hasPermission(PERMISSIONS.CANCEL_SPECIAL_GOHONZON) ||
        hasPermission(
          PERMISSIONS.ALLOTMENT_SPECIAL_APPLICATION_CANCEL_REQUEST_GOHONZON
        ) ||
        hasPermission(PERMISSIONS.ALLOTMENT_OKATAKI_APPLICATION_GOHONZON) ||
        hasPermission(
          PERMISSIONS.BATCH_HANDOVER_OKATAKI_APPLICATION_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.APPLICATION_HANDOVER_OKATAKI_APPLICATION_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.ALLOTMENT_CANCEL_HANDOVER_OKATAKI_APPLICATION_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.RETURN_REQUEST_HANDOVER_OKATAKI_APPLICATION_GOHONZON
        ) ||
        hasPermission(PERMISSIONS.ALLOTMENT_OMAMORI_APPLICATION_GOHONZON) ||
        hasPermission(PERMISSIONS.HANDOVER_OMAMORI_APPLICATION_GOHONZON) ||
        hasPermission(PERMISSIONS.OTP_OMAMORI_APPLICATION_GOHONZON) ||
        hasPermission(
          PERMISSIONS.ALLOTMENT_CANCEL_HANDOVER_OMAMORI_APPLICATION_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.RETURN_REQUEST_HANDOVER_OMAMORI_APPLICATION_GOHONZON
        ) ||
        hasPermission(
          PERMISSIONS.VIEW_MEMBER_FOR_SPECIAL_APPLICATION_GOHONZON
        ) ||
        hasPermission(PERMISSIONS.ALLOTMENT_SPECIAL_APPLICATION_GOHONZON) ||
        hasPermission(PERMISSIONS.HANDOVER_SPECIAL_APPLICATION_GOHONZON) ||
        hasPermission(PERMISSIONS.OTP_SPECIAL_APPLICATION_GOHONZON) ||
        hasPermission(
          PERMISSIONS.ALLOTMENT_CANCEL_HANDOVER_SPECIAL_APPLICATION_GOHONZON
        ) ||
        hasPermission(PERMISSIONS.GOHONZON_CONSENT_LINK) ||
        hasPermission(PERMISSIONS.GOHONZON_TRACKING)
      ) {
        accum.push({
          title: "Gohonzon",
          key: "gohonzon",
          isParent: true,
          icon: <GohonzonIcon />,
          path: ROUTES.GOHONZON.path,
          members: [
            hasPermission(PERMISSIONS.CREATE_OKATAKI_APPLICATION_GOHONZON) &&
              hasPermission(
                PERMISSIONS.CREATE_OMAMORI_APPLICATION_GOHONZON
              ) && {
                title: "Apply Gohonzon",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.APPLY_GOHONZON.path,
              },
            hasPermission(
              PERMISSIONS.VIEW_OMAMORI_APPLICATION_REMARK_GOHONZON
            ) &&
              hasPermission(
                PERMISSIONS.VIEW_OKATAKI_APPLICATION_REMARK_GOHONZON
              ) &&
              hasPermission(PERMISSIONS.VIEW_OMAMORI_APPLICATION_GOHONZON) &&
              hasPermission(PERMISSIONS.VIEW_OKATAKI_APPLICATION_GOHONZON) &&
              hasPermission(
                PERMISSIONS.VIEW_OKATAKI_APPLICATION_FOR_MEMBER_GOHONZON
              ) &&
              hasPermission(
                PERMISSIONS.UPDATE_OKATAKI_APPLICATION_OTP_GOHONZON
              ) &&
              hasPermission(PERMISSIONS.UPDATE_OKATAKI_APPLICATION_GOHONZON) &&
              hasPermission(PERMISSIONS.UPDATE_OMAMORI_APPLICATION_GOHONZON) &&
              hasPermission(PERMISSIONS.CANCEL_OKATAKI_GOHONZON) &&
              hasPermission(PERMISSIONS.CANCEL_OMAMORI_GOHONZON) && {
                title: "Applications",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.GOHONZON_APPLICATIONS.path,
              },
            // {
            //   title: "Application Verification",
            //   icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
            //   path: ROUTES.APPLICATION_VERIFICATION.path,
            // },
            //   ]
            // : []),

            hasPermission(
              PERMISSIONS.VIEW_OMAMORI_APPLICATION_REMARK_GOHONZON
            ) &&
              hasPermission(
                PERMISSIONS.VIEW_OKATAKI_APPLICATION_REMARK_GOHONZON
              ) &&
              hasPermission(PERMISSIONS.VIEW_OMAMORI_APPLICATION_GOHONZON) &&
              hasPermission(PERMISSIONS.VIEW_OKATAKI_APPLICATION_GOHONZON) &&
              hasPermission(
                PERMISSIONS.UPDATE_OMAMORI_APPLICATION_INTERVIEW_GOHONZON
              ) &&
              hasPermission(
                PERMISSIONS.UPDATE_OKATAKI_APPLICATION_INTERVIEW_GOHONZON
              ) &&
              hasPermission(
                PERMISSIONS.VIEW_OKATAKI_APPLICATION_FOR_MEMBER_GOHONZON
              ) &&
              hasPermission(PERMISSIONS.CANCEL_OKATAKI_GOHONZON) &&
              hasPermission(PERMISSIONS.CANCEL_OMAMORI_GOHONZON) && {
                title: "Pending Application",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.GOHONZON_INTERVIEW.path,
              },
            hasPermission(PERMISSIONS.CREATE_BATCH_GOHONZON) && {
              title: "Batch Processing",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.GOHONZON_VERIFICATION.path,
            },
            hasPermission(PERMISSIONS.CREATE_BATCH_GOHONZON) && {
              title: "Batch History",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.GOHONZON_BATCH_HISTORY.path,
            },

            hasPermission(
              PERMISSIONS.CREATE_OKATAKI_APPLICATION_RETURN_REQUEST_GOHONZON
            ) &&
              hasPermission(
                PERMISSIONS.CREATE_OMAMORI_APPLICATION_RETURN_REQUEST_GOHONZON
              ) && {
                title: "Return Gohonzon",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.GOHONZON_RETURN.path,
              },
            hasPermission(
              PERMISSIONS.UPDATE_OMAMORI_APPLICATION_CONFERRAL_GOHONZON
            ) &&
              hasPermission(
                PERMISSIONS.ALLOTMENT_OKATAKI_APPLICATION_CANCEL_REQUEST_GOHONZON
              ) &&
              hasPermission(PERMISSIONS.VIEW_BATCH_GOHONZON) &&
              hasPermission(
                PERMISSIONS.UPDATE_OKATAKI_APPLICATION_CONFERRAL_GOHONZON
              ) && {
                title: "Conferral",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                isParent: true,
                members: [
                  {
                    title: "Batch",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.GOHONZON_BATCH_CONFERRAL.path,
                  },
                  {
                    title: "Application",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.GOHONZON_OMAMORI_CONFERRAL.path,
                  },
                  {
                    title: "Replacement",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.GOHONZON_REPLACEMENT_CONFERRAL.path,
                  },
                ].filter(Boolean),
              },

            hasPermission(
              PERMISSIONS.VIEW_OMAMORI_APPLICATION_REMARK_GOHONZON
            ) &&
              hasPermission(
                PERMISSIONS.UPDATE_OMAMORI_APPLICATION_CONFERRAL_GOHONZON
              ) &&
              hasPermission(PERMISSIONS.VIEW_OMAMORI_APPLICATION_GOHONZON) &&
              hasPermission(
                PERMISSIONS.UPDATE_OMAMORI_APPLICATION_FINAL_INTERVIEW_GOHONZON
              ) &&
              hasPermission(PERMISSIONS.CANCEL_OMAMORI_GOHONZON) && {
                title: "Pending Application",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.GOHONZON_APPROVAL.path,
              },
            hasPermission(
              PERMISSIONS.UPDATE_OMAMORI_APPLICATION_RETURN_GOHONZON
            ) &&
              hasPermission(
                PERMISSIONS.UPDATE_OMAMORI_APPLICATION_RETURN_REQUEST_GOHONZON
              ) &&
              hasPermission(
                PERMISSIONS.ALLOTMENT_OMAMORI_APPLICATION_CANCEL_REQUEST_GOHONZON
              ) && {
                title: "Return Gohonzon",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.GOHONZON_RETURN_VERIFICATION.path,
              },

            hasPermission(
              PERMISSIONS.VIEW_OMAMORI_APPLICATION_REMARK_GOHONZON
            ) &&
              hasPermission(
                PERMISSIONS.ALLOTMENT_CANCEL_HANDOVER_OMAMORI_APPLICATION_GOHONZON
              ) &&
              hasPermission(
                PERMISSIONS.VIEW_OKATAKI_APPLICATION_REMARK_GOHONZON
              ) &&
              hasPermission(
                PERMISSIONS.ALLOTMENT_OMAMORI_APPLICATION_GOHONZON
              ) &&
              hasPermission(PERMISSIONS.VIEW_OMAMORI_APPLICATION_GOHONZON) &&
              hasPermission(PERMISSIONS.VIEW_OKATAKI_APPLICATION_GOHONZON) &&
              hasPermission(
                PERMISSIONS.VIEW_OKATAKI_APPLICATION_FOR_MEMBER_GOHONZON
              ) &&
              hasPermission(PERMISSIONS.VIEW_BATCH_GOHONZON) && {
                title: "Allotment",
                key: ALLOTMENT,
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                isParent: true,
                path: ROUTES.GOHOZON_APPLY_PAGE.path,
                members: [
                  {
                    title: "Batches",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.GOHONZON_BATCH_ALLOTMENT.path,
                  },
                  hasPermission(
                    PERMISSIONS.VIEW_OMAMORI_APPLICATION_FOR_MEMBER_GOHONZON
                  ) && {
                    title: "Applications",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.GOHONZON_OMAMORI_ALLOTMENT.path,
                  },
                ].filter(Boolean),
              },
            hasPermission(
              PERMISSIONS.BATCH_HANDOVER_OKATAKI_APPLICATION_GOHONZON
            ) &&
              hasPermission(
                PERMISSIONS.HANDOVER_OMAMORI_APPLICATION_GOHONZON
              ) &&
              hasPermission(PERMISSIONS.VIEW_BATCH_GOHONZON) && {
                title: "Handover",
                key: "handover",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                isParent: true,
                path: ROUTES.GOHOZON_APPLY_PAGE.path,
                members: [
                  {
                    title: "Batches",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.GOHONZON_HANDOVER.path,
                  },
                  {
                    title: "Applications",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.GOHONZON_OMAMORI_HANDOVER.path,
                  },
                ].filter(Boolean),
              },
            hasPermission(
              PERMISSIONS.ALLOTMENT_CANCEL_HANDOVER_OKATAKI_APPLICATION_GOHONZON
            ) && {
              title: "Cancel Request",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.GOHONZON_CANCELLATION.path,
            },

            hasPermission(
              PERMISSIONS.RETURN_REQUEST_HANDOVER_OMAMORI_APPLICATION_GOHONZON
            ) &&
              hasPermission(
                PERMISSIONS.RETURN_REQUEST_HANDOVER_OKATAKI_APPLICATION_GOHONZON
              ) && {
                title: "Returned Handover",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.GOHONZON_RETURNED_HANDOVER.path,
              },
            hasPermission(
              PERMISSIONS.ALLOTMENT_OKATAKI_APPLICATION_GOHONZON
            ) && {
              title: "Allotment History",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.ALLOTMENT_HISTORY.path,
            },
            {
              title: "Tracking",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.GOHONZON_TRACKING.path,
            },
            (userRole === helpDesk || userRole === helpDeskAdmin) && {
              title: "Gohonzon Inventory",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              isParent: true,
              members: [
                {
                  title: "Gohonzon Inventory",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.GOHONZON_INVENTORY.path,
                },
                {
                  title: "Handover Inventory",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.HANDOVER_INVENTORY.path,
                },
                {
                  title: "Master Inventory",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.MASTER_INVENTORY.path,
                },
              ].filter(Boolean),
            },
            hasPermission(PERMISSIONS.GOHONZON_CONSENT_LINK) && {
              title: "Gohonzon Consent Url",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.GOHONZON_CONSENT_URL.path,
            },
          ].filter(Boolean),
        });
      }
    } else if (key === APPOINTMENT) {
      if (
        hasPermission(PERMISSIONS.CREATE_APPLICATION_FOR_APPOINTMENT) ||
        hasPermission(PERMISSIONS.VIEW_APPLICATION_FOR_APPOINTMENT) ||
        hasPermission(
          PERMISSIONS.VIEW_RECCOMNDED_APPLICATION_FOR_APPOINTMENT
        ) ||
        hasPermission(PERMISSIONS.VIEW_APPROVE_APPLICATION_FOR_APPOINTMENT) ||
        hasPermission(PERMISSIONS.VIEW_LIST_APPLICATION_FOR_APPOINTMENT) ||
        hasPermission(PERMISSIONS.INTERVIEW_APPOINTMENT) ||
        hasPermission(PERMISSIONS.UPDATE_MARK_APPOINTMENT) ||
        hasPermission(PERMISSIONS.REJECT_APPOINTMENT) ||
        hasPermission(PERMISSIONS.REVIEW_APPOINTMENT) ||
        hasPermission(PERMISSIONS.REVIEW_PARTIAL_APPOINTMENT) ||
        hasPermission(PERMISSIONS.VIEW_PARTIAL_APPLICATION_FOR_APPOINTMENT) ||
        hasPermission(PERMISSIONS.CREATE_APPLICATION_FOR_DIRECT_APPOINTMENT) ||
        hasPermission(PERMISSIONS.VIEW_APPLICATION_FOR_DIRECT_APPOINTMENT) ||
        hasPermission(PERMISSIONS.VIEW_APPLICATION_FOR_ADHOC_APPOINTMENT) ||
        hasPermission(PERMISSIONS.VIEW_APPLICATION_FOR_AAC_FIRST_APPROVED) ||
        hasPermission(PERMISSIONS.VIEW_APPLICATION_FOR_AAC_SECOND_APPROVED)
      ) {
        accum.push({
          title: "Appointment",
          key: "appointment",
          isParent: true,
          icon: <MarkunreadMailboxOutlinedIcon style={Styles.settingIcon} />,
          path: ROUTES.APPOINTMENT.path,
          members: [
            //

            // Removed Appointment Cycle from UI for NOW

            hasPermission(PERMISSIONS.CREATE_APPLICATION_FOR_APPOINTMENT) && {
              title: "Apply",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.APPLY_APPOINTMENT.path,
            },
            hasPermission(
              PERMISSIONS.VIEW_RECCOMNDED_APPLICATION_FOR_APPOINTMENT
            ) && {
              title: "Recommendation",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.APPOINTMENT_REVIEW.path,
            },
            (hasPermission(
              PERMISSIONS.VIEW_APPLICATION_FOR_AAC_FIRST_APPROVED
            ) ||
              hasPermission(
                PERMISSIONS.VIEW_APPLICATION_FOR_AAC_SECOND_APPROVED
              )) && {
              title: "Approval",
              isParent: true,
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              members: [
                hasPermission(
                  PERMISSIONS.VIEW_APPLICATION_FOR_AAC_FIRST_APPROVED
                ) && {
                  title: "Approval Level 1",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.REVIEW_APPOINTMENT.path,
                },
                hasPermission(
                  PERMISSIONS.VIEW_APPLICATION_FOR_AAC_SECOND_APPROVED
                ) && {
                  title: "Approval Level 2",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.APPOINTMENT_SECOND_APPROVAL_APPLICATION.path,
                },
              ].filter(Boolean),
            },
            hasPermission(PERMISSIONS.INTERVIEW_APPOINTMENT) && {
              title: "Mark Interaction",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.APPOINTMENT_PROPOSE_APPLICATION.path,
            },
            // hasPermission(PERMISSIONS.UPDATE_MARK_APPOINTMENT) &&
            hasPermission(
              PERMISSIONS.VIEW_LIST_APPLICATION_FOR_APPOINTMENT
            ) && {
              title: "Appointment List",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.APPOINTMENT_PROPOSE_MARK_APPLICATION.path,
            },
            hasPermission(PERMISSIONS.GOHONZON_TRACKING) && {
              title: "Tracking",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.APPOINTMENT_TRACKING.path,
            },
            {
              title: "Organogram",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.NEW_STRUCTURE_VIEW_ORGANOGRAM.path,
            },

            (hasPermission(
              PERMISSIONS.CREATE_APPLICATION_FOR_DIRECT_APPOINTMENT
            ) ||
              hasPermission(
                PERMISSIONS.VIEW_APPLICATION_FOR_DIRECT_APPOINTMENT
              ) ||
              hasPermission(
                PERMISSIONS.VIEW_APPLICATION_FOR_ADHOC_APPOINTMENT
              )) && {
              title: "Mark Appointment",
              isParent: true,
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              members: [
                (userRole === helpDesk || userRole === helpDeskAdmin) && {
                  title: "Appointment Entry",
                  isParent: true,
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  members: [
                    {
                      title: "Area",
                      icon: (
                        <AdjustOutlinedIcon style={Styles.memberIconStyle} />
                      ),
                      path: ROUTES.APPOINTMENT_DIRECT.path,
                    },
                    {
                      title: "National",
                      icon: (
                        <AdjustOutlinedIcon style={Styles.memberIconStyle} />
                      ),
                      path: ROUTES.NATIONAL_APPOINTMENT.path,
                    },
                  ].filter(Boolean),
                },
                userRole !== helpDesk &&
                  userRole !== helpDeskAdmin && {
                    title: "Appointment Entry",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.APPOINTMENT_DIRECT.path,
                  },
                hasPermission(
                  PERMISSIONS.VIEW_APPLICATION_FOR_ADHOC_APPOINTMENT
                ) && {
                  title: "Adhoc Appointment",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.APPOINTMENT_ADHOC.path,
                },
                hasPermission(PERMISSIONS.READ_SPECIAL_GROUP_APPLICATIONS) && {
                  title: "FD / SD / UHG",
                  isParent: true,
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  members: [
                    hasPermission(
                      PERMISSIONS.READ_SPECIAL_GROUP_APPLICATIONS
                    ) && {
                      title: "Future Division",
                      icon: (
                        <AdjustOutlinedIcon style={Styles.memberIconStyle} />
                      ),
                      path: ROUTES.APPOINTMENT_FUTURE_DIVISION.path,
                    },
                    hasPermission(
                      PERMISSIONS.READ_SPECIAL_GROUP_APPLICATIONS
                    ) && {
                      title: "Student",
                      icon: (
                        <AdjustOutlinedIcon style={Styles.memberIconStyle} />
                      ),
                      path: ROUTES.APPOINTMENT_STUDENT.path,
                    },
                    userRole !== CHAPTER_SI &&
                      hasPermission(
                        PERMISSIONS.READ_SPECIAL_GROUP_APPLICATIONS
                      ) && {
                        title: "UHG",
                        icon: (
                          <AdjustOutlinedIcon style={Styles.memberIconStyle} />
                        ),
                        path: ROUTES.APPOINTMENT_UHG.path,
                      },
                    (userRole === helpDesk || userRole === helpDeskAdmin) && {
                      title: "National",
                      icon: (
                        <AdjustOutlinedIcon style={Styles.memberIconStyle} />
                      ),
                      path: ROUTES.NATIONAL_SPECIAL_APPOINTMENT.path,
                    },
                  ].filter(Boolean),
                },
                hasPermission(PERMISSIONS.READ_SPECIAL_GROUP_APPLICATIONS) && {
                  title: "UHG",
                  icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                  path: ROUTES.APPOINTMENT_UHG.path,
                },
              ].filter(Boolean),
            },
          ].filter(Boolean),
        });
      }
    } else if (key === NEW_STRUCTURE) {
      if (
        hasPermission(PERMISSIONS.SPLIT_CHECK_STRUCTURE_CREATE) ||
        hasPermission(PERMISSIONS.SPLIT_CHECK_STRUCTURE_UPDATE)
      ) {
        accum.push({
          ...current,
          members: [
            {
              title: "Bulk Transfer",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.NEW_STRUCTURE_BULK_TRANSFER.path,
            },
            {
              title: "Search/ Add",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.NEW_STRUCTURE_APPLY.path,
            },
          ],
        });
      }
    } else if (key === SETTINGS) {
      if (
        hasPermission(PERMISSIONS.CREATE_ANNOUNCEMENT) ||
        hasPermission(PERMISSIONS.VIEW_ANNOUNCEMENT) ||
        hasPermission(PERMISSIONS.UPDATE_ANNOUNCEMENT) ||
        hasPermission(PERMISSIONS.ROLE_ASSIGNMENT)
      ) {
        accum.push({
          title: "Settings",
          key: "settings",
          isParent: true,
          icon: <SettingsIcon style={Styles.settingIcon} />,
          path: ROUTES.SETTINGS.path,
          members: [
            (hasPermission(PERMISSIONS.CREATE_ANNOUNCEMENT) ||
              hasPermission(PERMISSIONS.VIEW_ANNOUNCEMENT) ||
              hasPermission(PERMISSIONS.UPDATE_ANNOUNCEMENT)) && {
              title: "Announcement",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.VIEW_ANNOUNCEMENT.path,
            },
            (hasPermission(PERMISSIONS.CREATE_ANNOUNCEMENT) ||
              hasPermission(PERMISSIONS.VIEW_ANNOUNCEMENT) ||
              hasPermission(PERMISSIONS.UPDATE_ANNOUNCEMENT)) && {
              title: "University",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.UNIVERSITY_LIST.path,
            },
            userRole === helpDesk && {
              title: "Control Panel",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.CONTROL_PANEL.path,
            },
            (userRole === helpDesk || userRole === helpDeskAdmin) &&
              hasPermission(PERMISSIONS.ROLE_ASSIGNMENT) && {
                title: "User Management",
                isParent: true,
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.USER_MANAGEMENT.path,
                members: [
                  {
                    title: "Roles",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.USER_MANAGEMENT_MEMBER_SEARCH.path,
                  },
                  {
                    title: "Permissions",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.USER_PERMISSION_MANAGEMENT.path,
                  },
                  {
                    title: "IP Config",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.USER_IP_CONFIG_MANAGEMENT.path,
                  },
                  {
                    title: "Force Logout",
                    icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                    path: ROUTES.FORCE_LOGOUT.path,
                  },
                ],
              },
          ].filter(Boolean),
        });
      }
    } else if (key === TICKET_SYSTEM) {
      if (
        hasPermission(PERMISSIONS.CREATE_NEW_TICKET) ||
        // hasPermission(PERMISSIONS.UPDATE_TICKET) ||
        hasPermission(PERMISSIONS.VIEW_TICKET_DETAILS)
      ) {
        accum.push({
          title: "Ticket System",
          key: "ticketSystem",
          isParent: true,
          icon: <ImportantDevicesOutlinedIcon style={Styles.settingIcon} />,
          path: ROUTES.TICKET_SYSTEM.path,
          members: [
            hasPermission(PERMISSIONS.CREATE_NEW_TICKET) && {
              title: "Create Ticket",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.TICKET_CREATE.path,
            },
            hasPermission(PERMISSIONS.VIEW_TICKET_DETAILS) && {
              title: "Ticket List",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.TICKET_LIST.path,
            },
          ].filter(Boolean),
        });
      }
    } else {
      accum.push(current);
    }
    return accum;
  }, []);

const DRAWER_ITEMS_MOBILE = [
  {
    title: "Friends",
    icon: <HomeOutlinedIcon />,
    path: "/friends",
    key: FRIEND,
    isParent: true,
    members: [
      {
        title: "Transfer",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: `/${ROUTES.FRIEND_TRANSFER.path}`,
      },
    ],
  },
  {
    title: "Members",
    icon: <MemberIcon />,
    path: "/members",
    key: MEMBER,
    isParent: true,
    members: [
      {
        title: "Transfer",
        icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
        path: ROUTES.MEMBER_TRANSFER.path,
      },
    ],
  },
  {
    title: "Attendance",
    key: "attendance",
    isParent: true,
    icon: <TouchAppIcon style={Styles.settingIcon} />,
    path: ROUTES.MARK_ATTENDANCE.path,
  },
];

export const getMobileDrawerItems = (hasPermission, userRole) =>
  DRAWER_ITEMS_MOBILE.reduce((accum, current) => {
    const { key } = current;
    if (key === FRIEND) {
      if (
        hasPermission(PERMISSIONS.CREATE_NEW_ENTRY_FRIEND) ||
        hasPermission(PERMISSIONS.VIEW_PENDING_FRIEND)
      ) {
        accum.push({
          title: "Friends",
          icon: <FriendIcon />,
          path: "/friend",
          isParent: true,
          key: FRIEND,
          members: [
            hasPermission(PERMISSIONS.VIEW_PENDING_FRIEND) &&
              userRole !== helpDesk &&
              userRole !== helpDeskAdmin && {
                title: "Pending Transfer",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: `/${ROUTES.FRIEND_TRANSFER.path}`,
              },
            hasPermission(PERMISSIONS.VIEW_PENDING_FRIEND) &&
              (userRole === helpDesk || userRole === helpDeskAdmin) && {
                title: "Transfer Request",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: `/${ROUTES.FRIEND_TRANSFER_REQUEST.path}`,
              },
          ].filter(Boolean),
        });
      }
    } else if (key === MEMBER) {
      if (
        hasPermission(PERMISSIONS.CREATE_NEW_FAMILY) ||
        hasPermission(PERMISSIONS.VIEW_FAMILY_DETAILS) ||
        hasPermission(PERMISSIONS.VIEW_SEARCH_MEMBER) ||
        hasPermission(PERMISSIONS.VIEW_PENDING_MEMBER) ||
        hasPermission(PERMISSIONS.CREATE_NEW_ENTRY_MEMBER)
      ) {
        accum.push({
          title: "Members",
          icon: <MemberIcon />,
          path: "/members",
          isParent: true,
          key: MEMBER,
          members: [
            hasPermission(PERMISSIONS.VIEW_SEARCH_MEMBER) && {
              title: "Search",
              icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
              path: ROUTES.MEMBER_SEARCH.path,
            },
            hasPermission(PERMISSIONS.VIEW_PENDING_MEMBER) &&
              userRole !== helpDesk &&
              userRole !== helpDeskAdmin && {
                title: "Transfer",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.MEMBER_TRANSFER.path,
              },
            hasPermission(PERMISSIONS.VIEW_PENDING_MEMBER) &&
              (userRole === helpDesk || userRole === helpDeskAdmin) && {
                title: "Transfer Request",
                icon: <AdjustOutlinedIcon style={Styles.memberIconStyle} />,
                path: ROUTES.MEMBER_REQUEST.path,
              },
          ].filter(Boolean),
        });
      }
    } else if (key === MARK_ATTENDANCE) {
      if (hasAttendancePermission(hasPermission)) {
        accum.push({
          title: "Attendance",
          key: "attendance",
          isParent: true,
          icon: <MeetingAttendanceIcon />,
          path: ROUTES.MARK_ATTENDANCE.path,
        });
      }
    } else if (key === ARCHIVE_ATTENDANCE) {
      if (hasAttendancePermission(hasPermission)) {
        accum.push({
          title: "Archive Attendance",
          key: "archiveAttendance",
          isParent: true,
          icon: <MeetingAttendanceIcon />,
          path: ROUTES.ARCHIVE_MARK_ATTENDANCE.path,
        });
      }
    } else {
      accum.push(current);
    }
    return accum;
  }, []);
